import { Box, Divider, Typography } from '@mui/material';
import { formatNumber } from 'helpers';
import { usePortal_GetPortalTaskStatsByIdQuery } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import { useStyles } from './portal-task-stats.styles';

type TaskStatsProps = {
  portalId: string;
};

export const PortalTaskStats = ({ portalId }: TaskStatsProps) => {
  const classes = useStyles();

  const { data: portalTaskStatsData, loading: portalTaskStatsDataLoading } =
    usePortal_GetPortalTaskStatsByIdQuery({
      variables: {
        portalId,
      },
      onError: (e) => {
        showAlert({
          message: 'Error getting Portal task stats: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  if (portalTaskStatsDataLoading || !portalTaskStatsData?.data.completedTasksCount) {
    return null;
  }
  const portalTaskStats = portalTaskStatsData.data;
  const completedTasksCount = portalTaskStats.completedTasksCount;
  const dollarsSaved = portalTaskStats.totalDollarValue;

  return (
    <Box className={classes.statsContainer}>
      <Typography className={classes.statsLabel}>YOUR STATS</Typography>
      <img className={classes.statIcons} src="/icons/tasks-completed-icon.svg" alt="stat icons" />
      <Typography className={classes.statNumber}>{formatNumber(completedTasksCount)}</Typography>
      <Typography className={classes.statsTitle}>TASKS COMPLETED</Typography>
      <Divider orientation="vertical" flexItem variant="middle" className={classes.statsDivider} />
      <img className={classes.statIcons} src="/icons/dollars-saved-icon.svg" alt="stat icons" />
      <Typography className={classes.statNumber}>${formatNumber(dollarsSaved)}</Typography>
      <Typography className={classes.statsTitle}>DOLLARS SAVED</Typography>
    </Box>
  );
};
